<template>
	<v-row no-gutters>
		<v-col cols="3" class="pr-2">
			<v-img
				:src="
					reservation.customer && reservation.customer.image_url
						? reservation.customer.image_url
						: ' /images/image_placeholder.jpg'
				"
				width="100"
				height="100"
			></v-img>
		</v-col>
		<v-col cols="9">
			<v-list two-line dense>
				<v-list-item>
					<v-list-item-icon>
						<v-icon color="indigo"> mdi-account </v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{
							reservation.customer
								? reservation.customer.display_name
								: "N/A"
						}}</v-list-item-title>
						<v-list-item-subtitle>{{
							$t("Name")
						}}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-list-item>
					<v-list-item-icon>
						<v-icon color="indigo"> mdi-phone </v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{
							reservation.customer
								? reservation.customer.phone
								: "N/A"
						}}</v-list-item-title>
						<v-list-item-subtitle>{{
							$t("Phone")
						}}</v-list-item-subtitle>
					</v-list-item-content>

					<v-list-item-icon>
						<v-icon>mdi-message-text</v-icon>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item>
					<v-list-item-icon>
						<v-icon color="indigo"> mdi-email </v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{
							reservation.customer
								? reservation.customer.email
								: "N/A"
						}}</v-list-item-title>
						<v-list-item-subtitle>{{
							$t("label.email")
						}}</v-list-item-subtitle>
					</v-list-item-content>

					<v-list-item-icon>
						<v-icon>mdi-message-text</v-icon>
					</v-list-item-icon>
				</v-list-item>
			</v-list>
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: ["reservation"],
};
</script>